module.exports = __webpack_public_path__ + "img/BravoBeer.ac4ab2fb.svg";